import { useApis } from "@app/data/apis.ts";
import { ContentType } from "@app/data/engine.ts";
import { handleApiError } from "@app/helpers/error-helper.tsx";
import { tokenStore } from "@app/stores/auth.store.ts";
import { useMutation } from "@tanstack/react-query";

export default function useConnectData() {
    const apis = useApis();

    const loginMutation = useMutation({
        mutationFn: ({ username, password }: { username: string; password: string }) =>
            apis.engine.request({
                path: "/connect/token",
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: {
                    client_id: "www",
                    client_secret: "teirs-www",
                    grant_type: "password",
                    scope: "teirs openid profile",
                    username: username,
                    password: password,
                },
                type: ContentType.UrlEncoded,
                format: "json",
            }),
        onSuccess: (data) => {
            tokenStore.setState(() => data.access_token);
        },
        onError: (error: Error) => handleApiError(error, "Failed to login"),
    });

    return {
        login: loginMutation.mutateAsync,
    };
}
